import _ from 'lodash'

const codes = {
    400: {
        aliases: ['bad-request'],
        test: status => status === 400
    },
    401: {
        aliases: ['unauthorized'],
        test: status => status === 401
    },
    403: {
        aliases: ['forbidden'],
        test: status => status === 403
    },
    404: {
        aliases: ['not-found'],
        test: status => status === 404
    },
    405: {
        aliases: ['method-not-allowed'],
        test: status => status === 405
    },
    408: {
        aliases: ['request-timeout'],
        test: status => status === 408
    },
    413: {
        aliases: ['payload-too-large'],
        test: status => status === 413
    },
    422: {
        aliases: ['unprocessable-entity'],
        test: status => status === 422
    },
    429: {
        aliases: ['too-many-requests'],
        test: status => status === 429
    },
    500: {
        aliases: ['internal-server-error'],
        test: status => status === 500
    },
    502: {
        aliases: ['bad-gateway'],
        test: status => status === 502
    },
    503: {
        aliases: ['service-unavailable'],
        test: status => status === 503
    },
    504: {
        aliases: ['gateway-timeout'],
        test: status => status === 504
    },
    511: {
        aliases: ['network-authentication-required'],
        test: status => status === 511
    },
    '3xx': {
        aliases: ['redirect-error'],
        test: status => status >= 300 && status <= 399
    },
    '4xx': {
        aliases: ['client-error'],
        test: status => status >= 400 && status <= 499
    },
    '5xx': {
        aliases: ['server-error'],
        test: status => status >= 500 && status <= 599
    },
    'http-error': {
        test: status => _.isNumber(status)
    },
    'browser-error': {
        test: status => _.isUndefined(status)
    },
    error: {
        test: () => true
    }
}

class Error {
    install (Vue, options) {
        Vue.prototype.$error = {
            is (error, options) {
                let include = ['error']
                let exclude = []

                switch (true) {
                    case _.isString(options):
                    case _.isNumber(options):
                        include = [options]
                        break
                    case _.isArray(options):
                        include = options
                        break
                    default:
                        include = _.get(options, 'include', include)
                        exclude = _.get(options, 'exclude', exclude)
                }

                const status = _.get(error, 'response.status')

                // test to see if the errors pass any codes tests
                const test = (array) => {
                    return _.chain(array)
                        .thru(array => {
                            return _.isString(array) ? [array] : array
                        })
                        .map(value => {
                            return _.find(codes, ({ aliases = [] }, key) => {
                                return _.includes([key, ...aliases], _.toString(value))
                            })
                        })
                        .filter()
                        .map(({ test }) => {
                            return test(status)
                        })
                        .includes(true)
                        .value()
                }

                if (test(exclude)) {
                    return false
                }

                return test(include)
            },
            emit (context, error) {
                console.error(error)

                const status = _.get(error, 'response.status')

                _.each(codes, ({ aliases = [], test }, key) => {
                    if (test(status)) {
                        _.each([key, ...aliases], alias => context.$emit(_.camelCase(alias), error))
                    }
                })
            }
        }
    }
}

export default new Error()
